// extracted by mini-css-extract-plugin
module.exports = {"root":"Item-module--root--2Rjvl","wrap":"Item-module--wrap--jgOCm","title":"Item-module--title--3t0W8","days":"Item-module--days--iJPOs","image":"Item-module--image--2_RPP"};